import type { SVGProps } from 'react';

/** Norway — red field with a white-bordered blue Nordic cross. Decorative (`aria-hidden`); see `GbFlag` for sizing/crop notes. */
export const NoFlag = ({ width = '17', height = '12', ...props }: SVGProps<SVGSVGElement>) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 60 30"
        preserveAspectRatio="xMidYMid slice"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}>
        <rect width="60" height="30" fill="#BA0C2F" />
        <rect y="10" width="60" height="10" fill="#fff" />
        <rect x="10" width="10" height="30" fill="#fff" />
        <rect y="12" width="60" height="6" fill="#00205B" />
        <rect x="12" width="6" height="30" fill="#00205B" />
    </svg>
);
